<template>
  <div class="card d-print-none mb-2">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-2">
              <label class="font-weight-bold float-right">Report Type</label>
            </div>
            <div class="col-4">
              <form id="formReportSearch">
                <div class="input-group" >
                  <select id="report_type" class="form-control" name="options[report_type]">
                    <option value="bom_single">Bom Single Level</option>
                    <option value="bom_indented">Bom Indented 7 Levels</option>
                    <option value="bom_indented_cost">Bom Indented 7 Levels w/cost</option>
                    <option value="bom_vendor_report">Flat Bom Report By Vendor</option>
                  </select>
                </div>
              </form>
            </div>
            <div class="col-4">
              <button  type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="showReport"><i class="feather icon-save"></i> {{labels.get('label_search')}}</button>
              <router-link :to="taskData.api_url" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" ><i class="feather icon-corner-up-left"></i> {{labels.get('label_back')}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="show_report">
    <div class="card-body pb-0 d-print-none">
      <button type="button" v-if="taskData.permissions.action_4" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" onclick="window.print();"><i class="feather icon-printer"></i> {{labels.get('action_4')}}</button>
      <button type="button" v-if="taskData.permissions.action_5" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="exportCsv"><i class="feather icon-download"></i> {{labels.get('action_5')}}</button>
    </div>

    <div>
      <table id="table_report_name"  class="table" style="font-weight: bolder;font-size: 30px">
        <tbody class="table-striped table-hover">
        <tr></tr>
        </tbody>
      </table>
      <table id="table_report_headings"  class="table" style="font-weight: bolder;font-size: larger">
        <tbody class="table-striped table-hover">
        </tbody>
      </table>
    </div>
    <div class="card-body" style='overflow-x:auto;height:600px;padding: 0'>
      <table id="table_report"  class="table table-bordered sticky">
        <thead class="table-active">

        </thead>
        <tbody class="table-striped table-hover">
        </tbody>
      </table>
    </div>
  </div>
</template>
<script setup>

import globalVariables from "@/assets/globalVariables";
import systemFunctions from "@/assets/systemFunctions";
import toastFunctions from "@/assets/toastFunctions";
import labels from '@/labels'

import ColumnSort from '@/components/ColumnSort.vue';
import ColumnFilter from '@/components/ColumnFilter.vue';
import Pagination from '@/components/Pagination.vue';

import {useRouter} from "vue-router";
import {inject, reactive, ref} from 'vue'
import axios from "axios";
import InputTemplate from '@/components/InputTemplate.vue';
import {useRoute} from "vue-router/dist/vue-router";


const route =useRoute()
const router =useRouter()
let show_report=ref(false)
let taskData = inject('taskData')
let item=reactive({
  id:0,
  exists:false,
  data:{
  }
})

const getItem=async ()=>{
  await axios.get(taskData.api_url+'/get-item-tree/'+ item.id).then((res)=>{
    if (res.data.error == "") {
      item.data=res.data.item;
      let pns_info=item.data.pns_info;
      let vendor_data={}
      let vendor_total_cost=0;
      for(let pn_id in pns_info){
        let pn=pns_info[pn_id];
        let vendor_id=pn['vendor1_id']?pn['vendor1_id']:0;
        if(!vendor_data[vendor_id]){
          vendor_data[vendor_id]={}
          vendor_data[vendor_id]['pns']=[]
          vendor_data[vendor_id]['ext_cost']=0;
        }
        vendor_data[vendor_id]['pns'].push(pn)
        vendor_data[vendor_id]['ext_cost']+=(+pn['quantity_total'])*(+pn['cost']);
        vendor_total_cost+=(+pn['quantity_total'])*(+pn['cost']);

      }
      item.data.vendor_data=vendor_data;
      item.data.vendor_total_cost=vendor_total_cost;
      item.exists = true;
    }
    else{
      toastFunctions.showResponseError(res.data)
    }
  });
}
const getBomIndentedCostReportHtml=(children,pns_info)=>{
  let tbody='';
  for(let i in children){
    let child=children[i];
    let pn=pns_info[child.id];
    let unit_quantity=(+child['quantity']>0?+child['quantity_unit']:0);
    let unit_cost=(+pn['cost']>0?+pn['cost']:0);

    tbody+=('<tr>');
    tbody+=('<td>');
    for(let j=0;j<+children[i].level;j++){
      tbody+=('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
    }
    tbody+=(pn['part_number']+'</td>');
    tbody+=('<td class="text-right">'+pn['revision_manual']+'</td>');
    tbody+=('<td class="text-right">'+child['quantity']+'</td>');
    tbody+=('<td class="text-right">'+child['quantity_unit']+'</td>');
    tbody+=('<td>'+(pn['description']?pn['description']:'')+'</td>');
    tbody+=('<td>'+pn['type_code']+'</td>');
    tbody+=('<td class="text-right">'+(pn['cost']?pn['cost']:'')+'</td>');
    tbody+=('<td class="text-right">'+(unit_quantity*unit_cost)+'</td>');
    tbody+=('<td class="text-right">'+(+child['level']+1)+'</td>');
    tbody+=('</tr>');
    if(child.children){
      tbody+=getBomIndentedCostReportHtml(child.children,pns_info)
    }
  }
  return tbody;
}
const getBomIndentedReportHtml=(children,pns_info)=>{
  let tbody='';
  for(let i in children){
    let child=children[i];
    let pn=pns_info[child.id];

    tbody+=('<tr>');
    tbody+=('<td>');
    for(let j=0;j<+children[i].level;j++){
      tbody+=('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
    }
    tbody+=(pn['part_number']+'</td>');
    tbody+=('<td class="text-right">'+pn['revision_manual']+'</td>');
    tbody+=('<td class="text-right">'+child['quantity']+'</td>');
    tbody+=('<td class="text-right">'+child['quantity_unit']+'</td>');
    tbody+=('<td>'+(pn['description']?pn['description']:'')+'</td>');
    tbody+=('<td>'+pn['type_code']+'</td>');
    tbody+=('<td class="text-right">'+(+child['level']+1)+'</td>');
    tbody+=('</tr>');
    if(child.children){
      tbody+=getBomIndentedReportHtml(child.children,pns_info)
    }
  }
  return tbody;
}
const showReport=async ()=> {
  show_report.value = false;
  let options = {};
  $('#formReportSearch :input').each(function () {
    options[$(this).attr('id')] = $(this).val();
  });
  $('#table_report_name tbody tr').html('<td>'+$('#report_type option:selected').text()+'</td>')
  let item_pn=item.data.pns_info[item.id]
  let tbody_headings='';
  tbody_headings+='<tr>';
  tbody_headings+=('<td style="width: 300px;">'+item_pn['part_number']+'</td>');
  if(options['report_type']=='bom_vendor_report')
  {
    tbody_headings+=('<td>'+(item_pn['description']?item_pn['description']:'')+'</td>');
    tbody_headings+=('<td></td>');
    tbody_headings+=('<td></td>');
  }
  else{
    tbody_headings+=('<td>'+(item_pn['description']?item_pn['description']:'')+'</td>');
  }
  tbody_headings+=('<td style="width: 100px;">Rev: '+item_pn['revision_manual']+'</td>');
  tbody_headings+=('<td style="width: 320px;">Last Update: '+item_pn['created_at']+'</td>');
  if(options['report_type']=='bom_vendor_report')
  {
    tbody_headings+='<td style="width: 100px;text-align: right"><div>'+item.data.vendor_total_cost+'</div></td>';
  }
  tbody_headings+='</tr>';
  $('#table_report_headings tbody').html(tbody_headings)

  let thead='<tr>';
  if(options['report_type']=='bom_single')
  {
    thead+='<th style="width: 210px;"><div>Part</div></th>';
    thead+='<th style="width: 50px;"><div>Rev</div></th>';
    thead+='<th style="width: 50px;"><div>Qtn</div></th>';
    thead+='<th style=""><div>Description</div></th>';
    thead+='<th style="width: 110px;"><div>Part Type</div></th>';
  }
  else if(options['report_type']=='bom_indented')
  {
    thead+='<th style="width: 310px;"><div>Part</div></th>';
    thead+='<th style="width: 50px;"><div>Rev</div></th>';
    thead+='<th style="width: 50px;"><div>Qtn</div></th>';
    thead+='<th style="width: 50px;"><div>Qtn Total</div></th>';
    thead+='<th style=""><div>Description</div></th>';
    thead+='<th style="width: 110px;"><div>Type</div></th>';
    thead+='<th style="width: 110px;"><div>Level</div></th>';
  }
  else if(options['report_type']=='bom_indented_cost')
  {
    thead+='<th style="width: 310px;"><div>Part</div></th>';
    thead+='<th style="width: 50px;"><div>Rev</div></th>';
    thead+='<th style="width: 50px;"><div>Qtn</div></th>';
    thead+='<th style="width: 50px;"><div>Qtn Total</div></th>';
    thead+='<th style=""><div>Description</div></th>';
    thead+='<th style="width: 110px;"><div>Type</div></th>';
    thead+='<th style="width: 100px;"><div>Unit Cost</div></th>';
    thead+='<th style="width: 100px;"><div>Ext Cost</div></th>';
    thead+='<th style="width: 50px;"><div>Level</div></th>';
  }
  else if(options['report_type']=='bom_vendor_report')
  {
    thead+='<th style="width: 310px;"><div>Vendor/Part</div></th>';
    thead+='<th style="width: 50px;"><div>Rev</div></th>';
    thead+='<th style=""><div>Description</div></th>';
    thead+='<th style="width: 50px;"><div>Qtn Total</div></th>';
    thead+='<th style="width: 50px;"><div>Unt</div></th>';
    thead+='<th style="width: 100px;"><div>Unit Cost</div></th>';
    thead+='<th style="width: 100px;"><div>Ext Cost</div></th>';
  }
  thead+='</tr>';



  let tbody='';
  if(options['report_type']=='bom_single')
  {
    let pns_info=item.data.pns_info;
    for(let pn_id in pns_info){
      let pn=pns_info[pn_id];
      tbody+='<tr>';
      tbody+=('<td>'+pn['part_number']+'</td>');
      tbody+=('<td>'+pn['revision_manual']+'</td>');
      tbody+=('<td class="text-right">'+pn['quantity_total']+'</td>');
      tbody+=('<td>'+(pn['description']?pn['description']:'')+'</td>');
      tbody+=('<td>'+pn['type_code']+'</td>');
      tbody+='</tr>';
    }
  }
  else if(options['report_type']=='bom_indented'){
    let tree=item.data.tree;
    let pns_info=item.data.pns_info;
    tbody=getBomIndentedReportHtml(tree,pns_info)

  }
  else if(options['report_type']=='bom_indented_cost'){
    let tree=item.data.tree;
    let pns_info=item.data.pns_info;
    tbody=getBomIndentedCostReportHtml(tree,pns_info)

  }
  else if(options['report_type']=='bom_vendor_report')
  {
    let vendor_data=item.data.vendor_data;
    for(let vendor_id in vendor_data){
      let vendor_datum=vendor_data[vendor_id];
      let vendor_name=(vendor_id>0?taskData.vendors.find(vendor=>vendor.id==vendor_id).name:'');
        tbody+='<tr style="font-weight: bolder">';
        tbody+=('<td>'+vendor_name+'</td>');
        tbody+=('<td></td>');
        tbody+=('<td></td>');
        tbody+=('<td></td>');
        tbody+=('<td></td>');
        tbody+=('<td></td>');
        tbody+=('<td class="text-right">'+vendor_datum['ext_cost']+'</td>');
        tbody+='</tr>';
        for(let i in vendor_datum['pns']){
          let pn=vendor_datum['pns'][i];
          let quantity_total=(+pn['quantity_total']);
          let unit_cost=(+pn['cost']>0?+pn['cost']:0);
          tbody+='<tr>';
          tbody+=('<td>'+pn['part_number']+'</td>');
          tbody+=('<td>'+pn['revision_manual']+'</td>');
          tbody+=('<td>'+(pn['description']?pn['description']:'')+'</td>');
          tbody+=('<td class="text-right">'+quantity_total+'</td>');
          tbody+=('<td>'+pn['unit']+'</td>');
          tbody+=('<td class="text-right">'+unit_cost+'</td>');
          tbody+=('<td class="text-right">'+(quantity_total*unit_cost)+'</td>');
          tbody+='</tr>';
        }
    }
  }
  $('#table_report thead').html(thead)
  $('#table_report tbody').html(tbody)
  show_report.value = true;
}
const exportCsv=async ()=>{
  let csv1=systemFunctions.getCsvStringFromHtmlTable('#table_report_headings');
  let csv2=systemFunctions.getCsvStringFromHtmlTable('#table_report');
  let file_name=$('#report_type option:selected').text();
  file_name+=('-'+item.data.pns_info[item.id]['part_number'])
  systemFunctions.exportCsvFromCsvString(csv1+csv2,file_name)
  //systemFunctions.exportCsvFromHtmlTable('#table_report',"Part Number "+$('#report_type option:selected').text())
}
  item.id=route.params['item_id']?route.params['item_id']:0;
  if(!(taskData.permissions.action_1)){
    toastFunctions.showAccessDenyMessage();
  }
  else{
    getItem()
  }
</script>